import {
  Badge,
  BadgeSize,
  BadgeVariant,
  Checkbox,
  CheckboxSize,
  Show
} from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import type {
  InstructionTarget,
  InstructionType
} from "types/landlord/address";
import {
  getTargetSource,
  getUnitName,
  INSTRUCTION_TYPE_LABELS
} from "./helpers";

const SourceBadge = ({
  target,
  type
}: {
  target: InstructionTarget;
  type: InstructionType;
}) => {
  const isCustom = getTargetSource(target, type) === "custom";

  return (
    <Badge
      className="shrink-0"
      size={BadgeSize.SM}
      variant={isCustom ? BadgeVariant.WARNING : BadgeVariant.BASE}
    >
      {`${INSTRUCTION_TYPE_LABELS[type].split(" ")[0]}: ${isCustom ? "Custom" : "Template"}`}
    </Badge>
  );
};

export const InstructionTargetRow = ({
  target,
  selectedTypes,
  checked,
  onToggle
}: {
  target: InstructionTarget;
  selectedTypes: InstructionType[];
  checked: boolean;
  onToggle: () => void;
}) => {
  const dictionary = useUnitsPropertiesDictionary();
  const isLocked = target.pms_locked;

  return (
    <div
      className={`flex items-center justify-between gap-4 rounded-lg px-3 py-2 transition-colors ${
        isLocked ? "opacity-60" : "cursor-pointer hover:bg-background-900"
      }`}
      onClick={isLocked ? undefined : onToggle}
      role="presentation"
    >
      <div className="min-w-0">
        <span onClick={(event) => event.stopPropagation()} role="presentation">
          <Checkbox
            checked={checked}
            disabled={isLocked}
            id={`instruction-target-${target.id}`}
            label={getUnitName(target, dictionary)}
            onChange={onToggle}
            size={CheckboxSize.SM}
          />
        </span>
        <p className="truncate pl-6 text-sm text-content-400">
          {target.address || "No address"}
        </p>
      </div>

      <div className="flex shrink-0 items-center gap-1">
        <Show if={isLocked}>
          <Badge
            className="shrink-0"
            size={BadgeSize.SM}
            variant={BadgeVariant.ERROR}
          >
            Locked by PMS
          </Badge>
        </Show>
        {selectedTypes.map((type) => (
          <SourceBadge key={type} target={target} type={type} />
        ))}
      </div>
    </div>
  );
};
